import produce from 'immer';
import { createReducer } from 'typesafe-actions';
import {
  DELETE_INVOICE,
  DELETE_INVOICE_ERROR,
  DELETE_INVOICE_SUCCESS,
  GET_INVOICE_LIST,
  GET_INVOICE_LIST_ERROR,
  GET_INVOICE_LIST_SUCCESS,
  UPDATE_INVOICE,
  UPDATE_INVOICE_ERROR,
  UPDATE_INVOICE_SUCCESS,
  GET_INVOICE_DETAIL,
  GET_INVOICE_DETAIL_SUCCESS,
  GET_INVOICE_DETAIL_ERROR,
  CREATE_INVOICE,
  CREATE_INVOICE_SUCCESS,
  CREATE_INVOICE_ERROR,
  CREATE_INVOICE_COMMENT,
  CREATE_INVOICE_COMMENT_SUCCESS,
  CREATE_INVOICE_COMMENT_ERROR,
  CREATE_SUB_INVOICE,
  CREATE_SUB_INVOICE_SUCCESS,
  CREATE_SUB_INVOICE_ERROR,
  EXCLUDE_SUB_INVOICE,
  EXCLUDE_SUB_INVOICE_SUCCESS,
  EXCLUDE_SUB_INVOICE_ERROR,
  UPDATE_INVOICE_STATUS,
  UPDATE_INVOICE_STATUS_SUCCESS,
  UPDATE_INVOICE_STATUS_ERROR,
  CREATE_INVOICE_PAYMENT,
  CREATE_INVOICE_PAYMENT_SUCCESS,
  CREATE_INVOICE_PAYMENT_ERROR,
} from './actions';
import { InvoicesAction, InvoicesState } from './types';

const initialState: InvoicesState = {
  invoices: {
    loading: false,
    data: [] || null,
    error: null,
  },
  invoice: {
    loading: false,
    data: null,
    error: null,
  },
};

const invoices = createReducer<InvoicesState, InvoicesAction>(initialState, {
  [GET_INVOICE_LIST]: (state) => ({
    ...state,
    invoices: {
      loading: true,
      error: null,
      data: null,
    },
  }),

  [GET_INVOICE_LIST_SUCCESS]: (state, action) => ({
    ...state,
    invoices: {
      loading: false,
      error: null,
      data: action.payload,
    },
  }),
  [GET_INVOICE_LIST_ERROR]: (state, action) => ({
    ...state,
    invoices: {
      loading: false,
      error: action.payload,
      data: null,
    },
  }),

  [CREATE_INVOICE]: (state) =>
    produce(state, (draft) => {
      draft.invoices.loading = true;
      draft.invoices.error = null;
    }),
  [CREATE_INVOICE_SUCCESS]: (state, action) =>
    produce(state, (draft) => {
      draft.invoices.data?.unshift(action.payload);
      draft.invoices.loading = false;
      draft.invoices.error = null;
    }),
  [CREATE_INVOICE_ERROR]: (state, action) =>
    produce(state, (draft) => {
      draft.invoices.loading = false;
      draft.invoices.error = action.payload;
    }),

  [UPDATE_INVOICE]: (state) => ({
    ...state,
    invoice: {
      loading: true,
      error: null,
      data: null,
    },
  }),
  [UPDATE_INVOICE_SUCCESS]: (state, action) =>
    produce(state, (draft) => {
      draft.invoice.data = action.payload;

      if (draft.invoices.data !== null) {
        const index: number = draft.invoices.data.findIndex(
          (invoice) => invoice.id === draft.invoice.data!.id,
        );

        if (index !== -1) {
          draft.invoices.data[index] = draft.invoice.data;
        }
      }

      draft.invoice.loading = false;
      draft.invoice.error = null;
    }),
  [UPDATE_INVOICE_ERROR]: (state, action) => ({
    ...state,
    invoice: {
      loading: false,
      error: action.payload,
      data: null,
    },
  }),

  [DELETE_INVOICE]: (state) =>
    produce(state, (draft) => {
      draft.invoices.loading = true;
      draft.invoices.error = null;
    }),
  [DELETE_INVOICE_SUCCESS]: (state, action) =>
    produce(state, (draft) => {
      if (draft.invoices.data !== null) {
        const index = draft.invoices.data.findIndex(
          (invoice) => invoice.id === action.payload,
        );
        draft.invoices.data.splice(index, 1);
      }
      draft.invoices.loading = false;
      draft.invoices.error = null;
    }),
  [DELETE_INVOICE_ERROR]: (state, action) =>
    produce(state, (draft) => {
      draft.invoices.loading = false;
      draft.invoices.error = action.payload;
    }),

  [GET_INVOICE_DETAIL]: (state) => ({
    ...state,
    invoice: {
      loading: true,
      error: null,
      data: null,
    },
  }),

  [GET_INVOICE_DETAIL_SUCCESS]: (state, action) => ({
    ...state,
    invoice: {
      loading: false,
      error: null,
      data: action.payload,
    },
  }),
  [GET_INVOICE_DETAIL_ERROR]: (state, action) => ({
    ...state,
    invoice: {
      loading: false,
      error: action.payload,
      data: null,
    },
  }),

  [CREATE_INVOICE_COMMENT]: (state) =>
    produce(state, (draft) => {
      draft.invoice.loading = true;
      draft.invoice.error = null;
    }),
  [CREATE_INVOICE_COMMENT_SUCCESS]: (state, action) =>
    produce(state, (draft) => {
      if (draft.invoice.data !== null) {
        draft.invoice.data.invoiceHistories.push(action.payload);
        if (draft.invoices.data !== null) {
          const index: number = draft.invoices.data.findIndex(
            (invoice) => invoice.id === draft.invoice.data!.id,
          );

          if (index !== -1) {
            draft.invoices.data[index] = draft.invoice.data;
          }
        }
      }
      draft.invoice.loading = false;
      draft.invoice.error = null;
    }),
  [CREATE_INVOICE_COMMENT_ERROR]: (state, action) =>
    produce(state, (draft) => {
      draft.invoice.loading = false;
      draft.invoice.error = action.payload;
    }),

  [CREATE_INVOICE_PAYMENT]: (state) => ({
    ...state,
    invoice: {
      loading: true,
      error: null,
      data: null,
    },
  }),
  [CREATE_INVOICE_PAYMENT_SUCCESS]: (state, action) =>
    produce(state, (draft) => {
      draft.invoice.data = action.payload;

      if (draft.invoices.data !== null) {
        const index: number = draft.invoices.data.findIndex(
          (invoice) => invoice.id === draft.invoice.data!.id,
        );

        if (index !== -1) {
          draft.invoices.data[index] = draft.invoice.data;
        }
      }

      draft.invoice.loading = false;
      draft.invoice.error = null;
    }),
  [CREATE_INVOICE_PAYMENT_ERROR]: (state, action) => ({
    ...state,
    invoice: {
      loading: false,
      error: action.payload,
      data: null,
    },
  }),

  [CREATE_SUB_INVOICE]: (state) =>
    produce(state, (draft) => {
      draft.invoice.loading = true;
      draft.invoice.error = null;
    }),
  [CREATE_SUB_INVOICE_SUCCESS]: (state, action) =>
    produce(state, (draft) => {
      if (draft.invoice.data !== null) {
        draft.invoice.data.children = action.payload;
        if (draft.invoices.data !== null) {
          const index: number = draft.invoices.data.findIndex(
            (invoice) => invoice.id === draft.invoice.data!.id,
          );
          if (index !== -1) {
            // add sub invoice
            draft.invoices.data[index] = draft.invoice.data;

            // remove duplicated sub invoice
            if (draft.invoices.data !== null) {
              draft.invoice.data.children.filter((ra) => {
                return (draft.invoices.data = draft.invoices.data!.filter(
                  function (sa) {
                    return sa.id !== ra.id;
                  },
                ));
              });
            }
          }
        }
      }
      draft.invoice.loading = false;
      draft.invoice.error = null;
    }),
  [CREATE_SUB_INVOICE_ERROR]: (state, action) =>
    produce(state, (draft) => {
      draft.invoice.loading = false;
      draft.invoice.error = action.payload;
    }),

  [EXCLUDE_SUB_INVOICE]: (state) =>
    produce(state, (draft) => {
      draft.invoice.loading = true;
      draft.invoice.error = null;
    }),
  [EXCLUDE_SUB_INVOICE_SUCCESS]: (state, action) =>
    produce(state, (draft) => {
      if (draft.invoice.data !== null) {
        const backupData: any[] = [];

        for (let i = 0; i < draft.invoice.data.children.length; i++) {
          let cnt = 0;
          for (let j = 0; j < action.payload.length; j++) {
            if (draft.invoice.data.children[i].id === action.payload[j].id)
              ++cnt;
          }
          if (cnt === 0) backupData.push(draft.invoice.data.children[i]);
        }

        draft.invoice.data.children = action.payload;
        if (draft.invoices.data !== null) {
          const index: number = draft.invoices.data.findIndex(
            (invoice) => invoice.id === draft.invoice.data!.id,
          );
          if (index !== -1) {
            // add sub invoice
            draft.invoices.data[index] = draft.invoice.data;
          }
          draft.invoices.data.push(...backupData);
        }
      }
      draft.invoice.loading = false;
      draft.invoice.error = null;
    }),
  [EXCLUDE_SUB_INVOICE_ERROR]: (state, action) =>
    produce(state, (draft) => {
      draft.invoice.loading = false;
      draft.invoice.error = action.payload;
    }),

  [UPDATE_INVOICE_STATUS]: (state) => ({
    ...state,
    invoice: {
      loading: true,
      error: null,
      data: null,
    },
  }),
  [UPDATE_INVOICE_STATUS_SUCCESS]: (state, action) =>
    produce(state, (draft) => {
      draft.invoice.data = action.payload;

      if (draft.invoices.data !== null) {
        const index: number = draft.invoices.data.findIndex(
          (invoice) => invoice.id === draft.invoice.data!.id,
        );

        if (index !== -1) {
          draft.invoices.data[index] = draft.invoice.data;
        }
      }

      draft.invoice.loading = false;
      draft.invoice.error = null;
    }),
  [UPDATE_INVOICE_STATUS_ERROR]: (state, action) => ({
    ...state,
    invoice: {
      loading: false,
      error: action.payload,
      data: null,
    },
  }),
});

export default invoices;
